<template>
  <v-row class="d-flex justify-center mt-0">
    <v-col cols="12">
      <!-- FILTROS -->
      <v-expansion-panels v-model="panel">
        <v-expansion-panel readonly>
          <v-btn
            style="position: absolute; top: -15px; right: 55px; z-index: 1"
            color="success"
            small
            fab
            @click="open_dialog(null)"
          >
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <v-expansion-panel-header class="py-0 px-4 text-h5" style="cursor: default">
            <div>
              <v-icon class="mb-1" left>fas fa-filter</v-icon>
              Filtro
            </div>
            <template v-slot:actions>
              <v-btn icon @click.stop="panel = panel === 1 ? 0 : 1">
                <v-icon>fas fa-chevron-down</v-icon>
              </v-btn>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-1">
            <v-form @submit.prevent="buscar()">
              <v-row>
                <v-col cols="12" sm="6" md="4" class="py-1">
                  Tipo Comprobante
                  <v-autocomplete
                    v-model="filtro.tipo_comp"
                    item-text="nombre"
                    item-value="id"
                    tabindex="1"
                    :items="tipos_comp.filter(tc => tc.inhabilitado != 1 && tc.tipifica == 1)"
                    hide-details
                    autofocus
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-1">
                  Descripción
                  <v-text-field
                    v-model.trim="filtro.descripcion"
                    tabindex="1"
                    hide-details
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="5" sm="2" class="py-1">
                  Inhabilitada
                  <v-autocomplete
                    v-model="filtro.inhabilitada"
                    tabindex="1"
                    :items="opciones"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <BtnFiltro
                  :loading="load"
                  @clear="limpiar()"
                />
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- DATA TABLE -->
      <v-data-table
        class="cebra elevation-2 mt-2"
        :items="tipif"
        :headers="headers"
        dense
      >
        <template v-slot:[`item.comprobante`]="{ item }">
          {{ tipos_comp.find(tp => tp.id == item.comprobante ).nombre }}
        </template>
        <template v-slot:[`item.inhabilitado`]="{ item }">
          {{ item.inhabilitado ? 'SÍ' : 'NO' }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            color="indigo"
            title="Editar"
            class="mr-2"
            small
            @click="open_dialog(item)"
          >
            fas fa-pen
          </v-icon>
          <BtnConfirmar
            :icono="item.inhabilitado ? 'fas fa-check' : 'fas fa-ban'"
            :color="item.inhabilitado ? 'success' : 'error'"
            :title="item.inhabilitado ? 'Habilitar' : 'Inhabilitar'"
            :texto="item.inhabilitado
              ? `¿Desea <strong>habilitar</strong> la tipificación <strong>${item.nombre}</strong> para el tipo de comprobante <strong>${tipos_comp.find(tp => tp.id == item.comprobante ).nombre}</strong>?`
              : `¿Desea <strong>inhabilitar</strong> la tipificación <strong>${item.nombre}</strong> para el tipo de comprobante <strong>${tipos_comp.find(tp => tp.id == item.comprobante ).nombre}</strong>?`"
            :icon_button="true"
            :small="true"
            @action="item.inhabilitado ? habilitar(item) : inhabilitar(item)"
          />
        </template>
        <template v-slot:no-data>
          <v-alert
            class="mx-auto mt-4"
            max-width="400"
            type="warning"
            border="left"
            dense
            text
          >
            No hay datos para los filtros seleccionados
          </v-alert>
        </template>
      </v-data-table>
    </v-col>
    <Tipificacion
      v-model="dialog"
      :p_tipificacion="tipificacion"
    />
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { nvl, order_list_by } from '../../util/utils'
import BtnFiltro from '../../components/util/BtnFiltro'
import BtnConfirmar from '../../components/util/BtnConfirmar'
import Tipificacion from '../../components/auditoria/Tipificacion'

export default {
  data () {
    return {
      panel: 0,
      load: false,
      dialog: false,
      tipif: [],
      headers: [
        { text: 'Tipificacion', value: 'nombre' },
        { text: 'Tipo comprobante', value: 'comprobante' },
        { text: 'Inhabilitada', value: 'inhabilitado' },
        { text: 'Acciones', value: 'actions', sortable: false, filterable: false },
      ],
      opciones: [
        { text: 'SI', value: 1 },
        { text: 'NO', value: 0 }
      ],
      tipificacion: {},
      filtro: {
        tipo_comp: null,
        descripcion: null,
        inhabilitada: null
      }
    }
  },
  async created () {
    this.$store.state.loading = true
    await this.$store.dispatch('controlCaja/get_tipos')
    this.$store.state.loading = false
  },
  computed: {
    ...mapState('controlCaja', ['tipos_comp', 'tipificaciones'])
  },
  components: {
    BtnFiltro,
    BtnConfirmar,
    Tipificacion
  },
  methods: {
    async inhabilitar (item) {
      this.$store.state.loading = true
      await this.$store.dispatch('controlCaja/inhabilitar_tipificacion', item.id)
        .then((res) => {
          this.$store.dispatch('show_snackbar', {
            text: res.message,
            color: 'success'
          })
          // modifica la tipificacion al array del store
          item.inhabilitado = 1
          this.$store.commit('controlCaja/set_tipificacion', item)
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error'
          })
        })
      this.$store.state.loading = false
    },
    async habilitar (item) {
      this.$store.state.loading = true
      await this.$store.dispatch('controlCaja/habilitar_tipificacion', item.id)
        .then((res) => {
          this.$store.dispatch('show_snackbar', {
            text: res.message,
            color: 'success'
          })
          // modifica la tipificacion al array del store
          item.inhabilitado = null
          this.$store.commit('controlCaja/set_tipificacion', item)
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error'
          })
        })
      this.$store.state.loading = false
    },
    async buscar () {
      if (!this.filtro.tipo_comp && !this.filtro.descripcion) {
        this.$store.dispatch('show_snackbar', {
          text: 'Debe seleccionar un tipo de comprobante o ingresar una descripción',
          color: 'warning'
        })
        return
      }
      let nombre = ''
      if (this.filtro.descripcion) {
        nombre = this.filtro.descripcion.toUpperCase()
      }
      this.load = true
      this.tipif = await this.tipificaciones.filter(
        t => (nvl(t.inhabilitado, 0) === this.filtro.inhabilitada || this.filtro.inhabilitada === null)
          && (t.comprobante == this.filtro.tipo_comp || this.filtro.tipo_comp === null)
          && (t.nombre.indexOf(nombre) >= 0)
      )
      this.load = false
      order_list_by(this.tipif, 'nombre')
    },
    open_dialog (item) {
      this.tipificacion = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    limpiar () {
      this.filtro = {
        tipo_comp: null,
        descripcion: null,
        inhabilitada: null
      }
    }
  }
}
</script>